export const navigationLinksMap: NavigationLinkMap = {
  issuer: [
    {
      name: 'Actionables',
      routerLink: '/issuer/actionables/nrd',
      is_auction_link: false
    },
    {
      name: 'Request For Quote (RFQ)',
      routerLink: '/issuer/price-discovery',
      is_auction_link: true
    },
    {
      name: 'Documents',
      routerLink: '/issuer/documentation',
      is_auction_link: false
    }
  ],
  investor: [
    {
      name: 'Actionables',
      routerLink: '/investor/actionables/nrd',
      is_auction_link: false
    },
    {
      name: 'Request For Quote (RFQ)',
      routerLink: '/investor/price-discovery',
      is_auction_link: true
    },
    {
      name: 'Ongoing Quotes',
      routerLink: '/investor/on-going-bids',
      is_auction_link: true
    },
    {
      name: 'Documents',
      routerLink: '/investor/documentation',
      is_auction_link: false
    }
  ],
  ipa: [
    {
      name: 'Pending',
      routerLink: '/ipa/new-processing',
      is_auction_link: false
    },
    {
      name: 'Signed Documents',
      routerLink: '/ipa/signed-docs',
      is_auction_link: false
    }
  ],
  onboarding: [
    {
      name: 'Corporate Details',
      routerLink: '/onboarding/corporate-details',
      is_auction_link: false
    },
    {
      name: 'Profile Details',
      routerLink: '/onboarding/profile-details',
      is_auction_link: false
    },
    {
      name: 'Manage Users',
      routerLink: '/onboarding/manage-users',
      is_auction_link: false
    }
  ],
  onboarding_investor: [
    {
      name: 'Profile Details',
      routerLink: '/onboarding/profile-details',
      is_auction_link: false
    },
    {
      name: 'Manage Users',
      routerLink: '/onboarding/manage-users',
      is_auction_link: false
    }
  ]
};

export const roleMap = {
  1: 'issuer',
  2: 'ipa',
  3: 'investor'
};

export const initNavigationMap = {
  1: 'onboarding'
};

interface NavigationLinkMap {
  [key: string]: NavigationLink[];
}

export interface NavigationLink {
  name: string;
  routerLink: string;
  is_auction_link: boolean;
}
